import { bs2ad as e } from "../../../calendar-carburettor/converter/index.js";
import "../../domains/index.js";
import t from "dayjs";
// src/design/forms/datepicker/calendar-engine/use-cases/english_date/get_normalized_date.ts
var n = e, r = (e, r) => {
	try {
		return r === "ENGLISH" ? t(e).format("YYYY-MM-DD") : t(n(e)).format("YYYY-MM-DD");
	} catch {}
};
export { r as get_normalized_date };

//# sourceMappingURL=get_normalized_date.js.map